import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message, Checkbox } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { apiLogin } from '../services/authService';

const Login = () => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const response = await apiLogin(values.username, values.password);
            
            // Lưu thông tin vào localStorage (tương tự AsyncStorage trên mobile)
            localStorage.setItem('accessToken', response.accessToken);
            localStorage.setItem('refreshToken', response.refreshToken);
            localStorage.setItem('userID', response.user.id.toString());
            localStorage.setItem('username', response.user.username);
            localStorage.setItem('job', response.user.part);
            localStorage.setItem('avatar', response.user.avatar);
            
            console.log('=== USER ROLE INFO ===');
            console.log('response.user.role_id:', response.user.role_id);
            console.log('Type of role_id:', typeof response.user.role_id);
            console.log('Is null:', response.user.role_id === null);
            console.log('Is undefined:', response.user.role_id === undefined);
            
            if (response.user.role_id === null || response.user.role_id === undefined) {
                console.log('Setting role to: user (default)');
                localStorage.setItem('role', 'user');
            } else {
                console.log('Setting role to:', response.user.role_id);
                localStorage.setItem('role', response.user.role_id);
            }
            
            console.log('Final role in localStorage:', localStorage.getItem('role'));
            console.log('======================');

            // Kiểm tra role_id có phải là leader không
            const userRole = response.user.role_id;
            console.log('Checking if user is leader:', userRole);
            
            if (userRole === 'leader' || userRole === 'Leader' || userRole === 'LEADER') {
                // Lưu tài khoản mật khẩu nếu user chọn "Ghi nhớ"
                if (values.remember) {
                    localStorage.setItem('savedUsername', values.username);
                    localStorage.setItem('savedPassword', values.password);
                    localStorage.setItem('rememberLogin', 'true');
                } else {
                    localStorage.removeItem('savedUsername');
                    localStorage.removeItem('savedPassword');
                    localStorage.removeItem('rememberLogin');
                }
                
                message.success('Đăng nhập thành công!');
                navigate('/home');
            } else {
                // Xóa thông tin đã lưu vì không phải leader
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('userID');
                localStorage.removeItem('username');
                localStorage.removeItem('job');
                localStorage.removeItem('avatar');
                localStorage.removeItem('role');
                
                console.log('Access denied - User role:', userRole);
                message.error('Chỉ có tài khoản leader mới vào được trang web này');
            }
        } catch (error) {
            console.error('Login error:', error);
            
            // Xử lý các loại lỗi khác nhau
            if (error.response) {
                // Server trả về lỗi
                const status = error.response.status;
                const errorMessage = error.response.data?.message || 'Đăng nhập thất bại';
                
                if (status === 401) {
                    message.error('Tên đăng nhập hoặc mật khẩu không đúng!');
                } else if (status === 404) {
                    message.error('Không tìm thấy API endpoint. Vui lòng kiểm tra cấu hình server!');
                } else if (status >= 500) {
                    message.error('Lỗi server. Vui lòng thử lại sau!');
                } else {
                    message.error(errorMessage);
                }
            } else if (error.request) {
                // Không có phản hồi từ server
                message.error('Không thể kết nối đến server. Vui lòng kiểm tra kết nối mạng!');
            } else {
                // Lỗi khác
                message.error('Đã xảy ra lỗi không mong muốn. Vui lòng thử lại!');
            }
        } finally {
            setLoading(false);
        }
    };

    // Load saved credentials khi component mount
    useEffect(() => {
        const rememberLogin = localStorage.getItem('rememberLogin');
        if (rememberLogin === 'true') {
            const savedUsername = localStorage.getItem('savedUsername');
            const savedPassword = localStorage.getItem('savedPassword');
            
            if (savedUsername && savedPassword) {
                form.setFieldsValue({
                    username: savedUsername,
                    password: savedPassword,
                    remember: true
                });
            }
        }
    }, [form]);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'linear-gradient(135deg, #134E4A 0%, #0F766E 45%, #14B8A6 100%)',
            padding: '20px'
        }}>
            <Card
                title={
                    <div style={{
                        textAlign: 'center',
                        fontSize: '24px',
                        fontWeight: 'bold',
                        color: '#0D9488'
                    }}>
                        Đăng nhập
                    </div>
                }
                style={{
                    width: '100%',
                    maxWidth: 400,
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                    borderRadius: '12px'
                }}
            >
                <Form
                    form={form}
                    name="login"
                    onFinish={onFinish}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item
                        label="Tên đăng nhập"
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: 'Vui lòng nhập tên đăng nhập!',
                            },
                        ]}
                    >
                        <Input
                            prefix={<UserOutlined />}
                            placeholder="Nhập tên đăng nhập của bạn"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Mật khẩu"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: 'Vui lòng nhập mật khẩu!',
                            },
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            placeholder="Nhập mật khẩu của bạn"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        name="remember"
                        valuePropName="checked"
                        style={{ marginBottom: '16px' }}
                    >
                        <Checkbox>Ghi nhớ tài khoản</Checkbox>
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            size="large"
                            style={{
                                width: '100%',
                                height: '45px',
                                fontSize: '16px',
                                fontWeight: 'bold'
                            }}
                        >
                            Đăng nhập
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default Login;
